import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
// Guards
import { AuthGuard } from './guards/auth.guard';
import { AuthReverseGuard } from './guards/auth-reverse.guard';
import { ShoppingCartGuard } from './guards/shopping-cart.guard';
import { CatalogueGuard } from './guards/catalogue.guard';
import { ReferralGuard } from './guards/referral.guard';
import { NewsGuard } from './guards/news.guard';
import { FeedGuard } from './guards/feed.guard';
import { VariantSelectorGuard } from './guards/variant-selector.guard';
import { WalletGuard } from './guards/wallet.guard';

const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: 'inicio',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'misiones',
    loadChildren: () => import('./pages/missions/missions.module').then(m => m.MissionsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'misiones/:id',
    loadChildren: () => import('./pages/mission-detail/mission-detail.module').then(m => m.MissionDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'productos',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'productos/:category',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'productos/:category/:product-tag',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'productos-en-promocion/:promotion',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'producto/:id',
    loadChildren: () => import('./pages/product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
    canActivate: [CatalogueGuard]
  },
  {
    path: 'perfil',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'carrito-de-compras',
    loadChildren: () => import('./pages/shopping-cart/shopping-cart.module').then(m => m.ShoppingCartPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'autenticacion',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthReverseGuard]
  },
  {
    path: 'detalles-de-entrega',
    loadChildren: () => import('./pages/delivery-address/delivery-address.module').then(m => m.DeliveryAddressPageModule),
    canActivate: [AuthGuard, ShoppingCartGuard]
  },
  {
    path: 'complete-order',
    loadChildren: () => import('./pages/complete-order/complete-order.module').then(m => m.CompleteOrderPageModule),
    canActivate: [AuthGuard, ShoppingCartGuard]
  },
  {
    path: 'product-slides',
    loadChildren: () => import('./modals/product-slides/product-slides.module').then(m => m.ProductSlidesPageModule)
  },
  {
    path: 'modal-add-address',
    loadChildren: () => import('./modals/modal-add-address/modal-add-address.module').then(m => m.ModalAddAddressPageModule)
  },
  {
    path: 'modal-points-info',
    loadChildren: () => import('./modals/modal-points-info/modal-points-info.module').then(m => m.ModalPointsInfoPageModule)
  },
  {
    path: 'modal-redeem-coupon',
    loadChildren: () => import('./modals/modal-redeem-coupon/modal-redeem-coupon.module').then(m => m.ModalRedeemCouponPageModule)
  },
  {
    path: 'modal-order-detail',
    loadChildren: () => import('./modals/modal-order-detail/modal-order-detail.module').then(m => m.ModalOrderDetailPageModule)
  },
  {
    path: 'restore-password',
    loadChildren: () => import('./modals/restore-password/restore-password.module').then(m => m.RestorePasswordPageModule)
  },
  {
    path: 'recuperar-credenciales/:uid/:token',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'modal-code-question',
    loadChildren: () => import('./modals/modal-code-question/modal-code-question.module').then(m => m.ModalCodeQuestionPageModule)
  },
  {
    path: 'modal-complete-information',
    loadChildren: () => import('./modals/modal-complete-information/modal-complete-information.module').then(m => m.ModalCompleteInformationPageModule)
  },
  {
    path: 'respuestas/:id',
    loadChildren: () => import('./pages/mission-responses/mission-responses.module').then(m => m.MissionResponsesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'epayco-confirmation',
    loadChildren: () => import('./pages/epayco-confirmation/epayco-confirmation.module').then(m => m.EpaycoConfirmationPageModule)
  },
  {
    path: 'epayco-response',
    loadChildren: () => import('./pages/epayco-response/epayco-response.module').then(m => m.EpaycoResponsePageModule)
  },
  // {
  //   path: 'registro-referidos',
  //   loadChildren: () => import('./pages/tigo/registro-referidos/registro-referidos.module').then(m => m.RegistroReferidosPageModule),
  //   canActivate: [ReferralGuard]
  // },
  {
    path: 'listar-referidos',
    loadChildren: () => import('./pages/tigo/listar-referidos/listar-referidos.module').then(m => m.ListarReferidosPageModule),
    canActivate: [ReferralGuard]
  },
  {
    path: 'modal-request-tigo-sale-order',
    loadChildren: () => import('./modals/tigo/modal-request-tigo-sale-order/modal-request-tigo-sale-order.module').then(m => m.ModalRequestTigoSaleOrderPageModule)
  },
  {
    path: 'noticias',
    loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule),
    canActivate: [AuthGuard, NewsGuard]
  },
  {
    path: 'news-detail',
    loadChildren: () => import('./modals/news-detail/news-detail.module').then(m => m.NewsDetailPageModule)
  },
  {
    path: 'muro',
    loadChildren: () => import('./pages/feed/feed.module').then(m => m.FeedPageModule),
    canActivate: [AuthGuard, FeedGuard]
  },
  {
    path: 'post-comments',
    loadChildren: () => import('./modals/post-comments/post-comments.module').then(m => m.PostCommentsPageModule)
  },
  {
    path: 'modal-user-goal-state',
    loadChildren: () => import('./modals/modal-user-goal-state/modal-user-goal-state.module').then(m => m.ModalUserGoalStatePageModule)
  },
  {
    path: 'modal-user-answers-questions',
    loadChildren: () => import('./modals/modal-user-answers-questions/modal-user-answers-questions.module').then(m => m.ModalUserAnswersQuestionsPageModule)
  },
  {
    path: 'trade-representative',
    loadChildren: () => import('./pages/trade-representative/trade-representative.module').then(m => m.TradeRepresentativeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'accept-terms-and-conditions',
    loadChildren: () => import('./modals/accept-terms-and-conditions/accept-terms-and-conditions.module').then(m => m.AcceptTermsAndConditionsPageModule)
  },
  {
    path: 'dependents',
    loadChildren: () => import('./pages/dependents/dependents.module').then(m => m.DependentsPageModule)
  },
  {
    path: 'selector-programa',
    loadChildren: () => import('./pages/variant-selector/variant-selector.module').then(m => m.VariantSelectorPageModule),
    canActivate: [AuthGuard, VariantSelectorGuard]
  },
  {
    path: 'kpi/:slug',
    loadChildren: () => import('./pages/kpi/kpi.module').then( m => m.KpiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'billetera',
    loadChildren: () => import('./pages/wallet/wallet.module').then( m => m.WalletPageModule),
    canActivate: [AuthGuard, WalletGuard]
  },
  {
    path: 'ranking',
    loadChildren: () => import('./pages/ranking/ranking.module').then( m => m.RankingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'oauth',
    loadChildren: () => import('./pages/oauth/oauth.module').then( m => m.OauthPageModule)
  },
  {
    path: '**',
    redirectTo: 'inicio'
  },
  {
    path: 'automatic-points-settings',
    loadChildren: () => import('./modals/automatic-points-settings/automatic-points-settings.module').then( m => m.AutomaticPointsSettingsPageModule)
  },
  {
    path: 'modal-additional-questions',
    loadChildren: () => import('./modals/modal-additional-questions/modal-additional-questions.module').then( m => m.ModalAdditionalQuestionsPageModule)
  },
  {
    path: 'modal-ia-results-resume',
    loadChildren: () => import('./modals/modal-ia-results-resume/modal-ia-results-resume.module').then( m => m.ModalIaResultsResumePageModule)
  },
  {
    path: 'filter-resume-results-by-date',
    loadChildren: () => import('./modals/filter-resume-results-by-date/filter-resume-results-by-date.module').then( m => m.FilterResumeResultsByDatePageModule)
  },
  {
    path: 'modal-ia-not-approved-rules',
    loadChildren: () => import('./modals/modal-ia-not-approved-rules/modal-ia-not-approved-rules.module').then( m => m.ModalIaNotApprovedRulesPageModule)
  },
  {
    path: 'modal-ia-activity-description',
    loadChildren: () => import('./modals/modal-ia-activity-description/modal-ia-activity-description.module').then( m => m.ModalIaActivityDescriptionPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
